/**
 * This error means we have some error with validation of server response
 *
 * It can be client error, but in most cases it server
 *
 * Also this error has two additional fields:
 * - `blockName` - Where error happens
 * - `originalData` - Original response
 */
export class ServerValidationError extends Error {
	originalData: unknown
	blockName: string

	constructor(blockName: string, message: string, originalData: unknown) {
		super(message)
		this.blockName = blockName
		this.name = `Server validation error`
		this.originalData = originalData
	}
}
